
import { Component, Vue, Watch, Prop, Emit, Ref } from "vue-property-decorator"
import { AdvancedSearchFilter, CalculationType } from "@/types"
import { operatorLabels, operatorsByFieldType } from "@/types/insights/operators"
import { CaseColumn } from "@/types/caseColumns"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import SearchFilter from "@/components/Search/SearchFilter.vue"
import cloneDeep from "lodash/cloneDeep"
import Guid from "@/scripts/guid"
import { BFormInput } from "bootstrap-vue"

@Component({
	components: {
		"search-filter": SearchFilter,
		"scrollbar": VuePerfectScrollbar
	}
})
export default class ColumnFilters extends Vue {
	@Ref() addFilterSearchInput!: BFormInput
	@Prop()
	value!: AdvancedSearchFilter[]

	@Prop()
	public filterColumnGroups!: CaseColumn[][]

	@Prop()
	allCaseFields!: CaseColumn[];

	@Prop({ default: false })
	allowOr!: boolean

	@Prop({ default: true })
	showApply!: boolean

	private filters: AdvancedSearchFilter[] = []
	private columnFilter: string = ""
	private filtersChanged: boolean = false

	componentId = Guid.newGuid()

	public get filteredFieldColumnGroups (): any[][] {
		let availableFilterColumnGroups = cloneDeep(this.filterColumnGroups)

		// Do not display the calculated field type - CalculationType.DaysUntilOrFromToday
		availableFilterColumnGroups.forEach(g => {
			g.removeWhere(f => f.fieldExtensions && f.fieldExtensions.calculationType === CalculationType.DaysUntilOrFromToday)
		})

		if (!this.columnFilter) {
			return availableFilterColumnGroups
		}
		const lowerFilter = this.columnFilter.toLowerCase()
		return availableFilterColumnGroups.map(g => g.filter((c: any) => c.label.toLowerCase().indexOf(lowerFilter) > -1))
	}

	public addFilterForColumn (column: CaseColumn) {
		const columnOperators = column.operators ? column.operators : operatorsByFieldType[column.dataType]
		const firstOperator = columnOperators && columnOperators.length > 0
			? operatorLabels.find(o => o.operator === columnOperators[0])
			: null

		this.filters.push({
			key: column.key,
			columnLabel: column.label,
			columnDataType: column.dataType,
			columnValues: column.columnValues,
			columnListLabel: column.listLabel,
			filterKey: column.filterKey,
			columnDataSource: column.dataSourceId,
			operator: firstOperator!.operator,
			operatorLabel: firstOperator!.label,
			dynamicValue: false,
			value: "",
			label: null,
			column: column
		})

		this.$nextTick(() => {
			let filterRef = this.$refs[`column-filters-${this.componentId}-${this.filters.length - 1}`]
			const filterElement = filterRef ? (filterRef as SearchFilter[])[0] : null
			if (filterElement && filterElement.open) filterElement.open()
		})
	}
	public addOr () {
		this.filters.push({
			key: "or-1",
			orFilters: []
		})
	}

	public removeFilter (filter: any) {
		this.filters.splice(this.filters.indexOf(filter), 1)
	}

	@Watch("filters", { deep: true })
	filtersUpdated () {
		this.filtersChanged = true
		this.$emit("input", this.filters)
	}

	@Emit("applyFilters")
	applyFilters () {
		this.filtersChanged = false
	}
}
